
export type GetStreamingInfo200DrmType = typeof GetStreamingInfo200DrmType[keyof typeof GetStreamingInfo200DrmType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfo200DrmType = {
  none: 'none',
  fairplay: 'fairplay',
  widevine: 'widevine',
  playready: 'playready',
} as const;
